import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import { Button, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import { updateLocation } from "_controllers/officer";
import haversine from "haversine-distance";
import "./styles.css"

const Main = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')

    const messageStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        // maxWidth: 500,
        bgcolor: "white",
        boxShadow: 24,
        p: 2,
        textAlign: 'center'
    };

    useEffect(async () => {
        const requests = await updateLocation();
        setData(requests?.dealersList);
        setLoading(true);
    }, [message])

    const handleApprove = async (id, latitude, longitude) => {
        const data = {
            status: "APPROVE",
            latitude,
            longitude,
        }
        const response = await authAxios()({
            url: `/api/v1/dealers/update-location?dealerId=${id}`,
            method: "POST",
            data
        });
        setMessage(response?.data.message);
        toastMessage("Location Approved", "success")
    };
    const handleRevert = async (id) => {
        const response = await authAxios()({
            url: `/api/v1/dealers/update-location?dealerId=${id}`,
            method: "POST",
        });
        toastMessage("Location Rejected.", "error")
        setMessage(response?.data.message);
    };

    const calculateDistance = (coordinates) => {
        const { lat1, long1, lat2, long2 } = coordinates
        const distance = haversine({ lat: lat1, lng: long1 }, { lat: lat2, lng: long2 })
        return isNaN(distance) ? "NA" : distance.toFixed(0)
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Box
                style={{
                    padding: "0px 20px",
                    border: "1px solid #eaeaea",
                    borderRadius: "10px",
                    boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                    // marginTop: "10px",
                    marginRight: "20px",
                }}
            >
                <Grid>
                    <p style={{ fontWeight: "bolder", fontSize: '1.25rem', padding: "1rem 0" }}>Dealer Location Update Request</p>
                </Grid>
            </Box>

            <Box style={{
                marginRight: "20px",
            }}>
                {loading ? (
                    <>
                        <TableContainer component={Paper} sx={{ mt: 3 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{ fontWeight: 'bolder' }}>SO ID</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer ID</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Updated On</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Existing Location</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Updated Location</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Distance (mtr)</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {data && data?.length > 0
                                        ? data?.map((d) => (
                                            <TableRow key={d._id}>
                                                <TableCell align="left">SO{d?.territoryCode}</TableCell>
                                                <TableCell align="left">
                                                    <div className="tooltip">
                                                        {d?.dealerCode}
                                                        <span className="tooltiptext">{d?.name}</span>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">{d?.locUpdatedOn ? moment(d?.locUpdatedOn).format("DD-MM-YYYY") : "-"}</TableCell>
                                                <TableCell align="center">
                                                    <div className="tooltip" style={{ cursor: "pointer", display: 'flex', flexDirection: 'column' }} onClick={() => {
                                                        setOpen(true);
                                                        setLat(d?.latitude
                                                            ? d?.latitude
                                                            : "NA")
                                                        setLong(d?.longitude
                                                            ? d?.longitude
                                                            : "NA")
                                                    }}>
                                                        <span>
                                                            lat :{" "}
                                                            {d?.latitude
                                                                ? d?.latitude
                                                                : "NA"}
                                                        </span>
                                                        <span>
                                                            long :{" "}
                                                            {d?.longitude
                                                                ? d?.longitude
                                                                : "NA"}
                                                        </span>
                                                        {/* <span className="tooltiptext">On Map</span> */}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div style={{ cursor: "pointer", display: 'flex', flexDirection: 'column' }} onClick={() => {
                                                        setOpen(true);
                                                        setLat(d?.updatedLatitude
                                                            ? d?.updatedLatitude
                                                            : "NA")
                                                        setLong(d?.updatedLongitude
                                                            ? d?.updatedLongitude
                                                            : "NA")
                                                    }}>
                                                        <span>
                                                            lat :{" "}
                                                            {d?.updatedLatitude
                                                                ? d?.updatedLatitude
                                                                : "NA"}
                                                        </span>
                                                        <span>
                                                            long :{" "}
                                                            {d?.updatedLongitude
                                                                ? d?.updatedLongitude
                                                                : "NA"}
                                                        </span>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">{
                                                    calculateDistance({
                                                        lat1: d?.updatedLatitude
                                                            ? d?.updatedLatitude
                                                            : 0,
                                                        long1: d?.updatedLongitude
                                                            ? d?.updatedLongitude
                                                            : 0,
                                                        lat2: d?.latitude
                                                            ? d?.latitude
                                                            : 0,
                                                        long2: d?.longitude
                                                            ? d?.longitude
                                                            : 0
                                                    })
                                                }</TableCell>
                                                <TableCell align="center">
                                                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                        {
                                                            d.updateLocationRequest ? (
                                                                <Button onClick={() => handleApprove(d?._id, d?.updatedLatitude, d?.updatedLongitude)} variant='contained'>Approve</Button>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        {d?.updateLocationRequest ? (
                                                            <Button onClick={() => handleRevert(d?._id)} variant='contained' color="error">Revert</Button>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        :
                                        <Box sx={{ textAlign: 'left', pt: 1 }}>
                                            <Typography variant="h6" sx={{ p: 1 }}>No Update Request Available.</Typography>
                                        </Box>}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>)
                    : (
                        <CircularProgress />
                    )}
            </Box>
            <Modal open={open} onClose={handleClose}>
                <Box sx={messageStyle}>
                    {/* <Grid container spacing={3}>
                        {console.log("first", lat, long)}
                        <Grid item xs={12}>
                            <h3>Are you sure ?</h3>
                        </Grid>
                        <Grid item xs={6}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>{' '}
                        </Grid>
                        <Grid item xs={6}>
                            <Button type="" variant="contained" color="error">
                                Delete
                            </Button>
                        </Grid>
                    </Grid> */}
                    <iframe src={`https://maps.google.com/maps?q=${lat},${long}&hl=es;&output=embed`} height="500px" width="100%"></iframe>
                </Box>
            </Modal>
        </>
    );
};

const UpdateLoaction = () => {
    return (
        <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
            <DashGridL2 Top={TopBar} Main={Main} />
            <Toaster />
        </AccessController>
    );
};

export default UpdateLoaction;
